const CURSOR_COLORS = [
  '#4D6D52', '#416A74', '#607B6E', '#6C6038',
  '#755875', '#547679', '#715940', '#A66DA1',
  '#70A39F', '#CA9089', '#85929E', '#8BAEC6',
  '#B57E8D', '#A75F5A', '#6B82B2', '#B28463',
]

export function getUserColor(seed: string): string {
  const hash = String(seed).split('').reduce((acc, c) => acc + c.charCodeAt(0), 0)
  return CURSOR_COLORS[Math.abs(hash) % CURSOR_COLORS.length]
}
